import { OTTSuccessContainer } from "@features/thankYou/containers/OTTSuccessContainer";
import { ScreenName } from "@motain/web-shared-hub/features";
import { usePageTracking } from "@features/tracking/hooks/usePageTracking";
import { useScreenName } from "@features/tracking/hooks/useScreenName";

export const ThankYouPage = () => {
  useScreenName(ScreenName.Thankyou);
  usePageTracking();
  return <OTTSuccessContainer />;
};
